import { createAction } from 'redux-actions';

import callApi from '../../util/apiCaller';
import { setError } from '../App/AppActions';

export const setEmailPreferencesCb = createAction('SET_EMAIL_PREFERENCES_CB');
export const fetchEmailPreferencesCb = createAction('FETCH_EMAIL_PREFERENCES_CB');

export function fetchEmailPreferences(token, payload, expiry, signature) {
  return dispatch => {
    if (payload && expiry && signature) {
      return callApi(dispatch, `email-preferences/${payload}/${expiry}/${signature}`, null).then(
        res => {
          dispatch(fetchEmailPreferencesCb(res));
          return res;
        },
      );
    }
    return callApi(dispatch, 'users/current/email-preferences', token).then(res => {
      dispatch(fetchEmailPreferencesCb(res));
      return res;
    });
  };
}

export function setEmailPreferencesPublic(
  payload,
  expiry,
  signature,
  group,
  unsubscribed,
  getErrorMessage,
) {
  return async dispatch => {
    try {
      const res = await callApi(
        dispatch,
        `email-preferences/${payload}/${expiry}/${signature}`,
        null,
        'PUT',
        { group, unsubscribed },
      );
      dispatch(setEmailPreferencesCb(res));
    } catch (err) {
      const msg = getErrorMessage(err);
      dispatch(setError(msg));
    }
  };
}

export function setEmailPreferences(group, unsubscribed, getErrorMessage) {
  return async dispatch => {
    try {
      const res = await callApi(dispatch, 'users/current/email-preferences', null, 'PUT', {
        group,
        unsubscribed,
      });
      dispatch(setEmailPreferencesCb(res));
    } catch (err) {
      const msg = getErrorMessage(err);
      dispatch(setError(msg));
    }
  };
}
